import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";

import api from "../../services/api";

// Seletor dos Agentes de IA (Application triggerType "agent") do projeto, usado
// pelo nó "Transferir para IA". Busca a lista por conta própria.
const AgentSelect = ({ value, onChange, label, projectId, disabled }) => {
  const [agents, setAgents] = useState([]);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const { data } = await api.get("/applications", { params: projectId ? { projectId } : {} });
        if (alive) setAgents((data.applications || []).filter(a => a.triggerType === "agent"));
      } catch {
        /* silencioso */
      }
    })();
    return () => {
      alive = false;
    };
  }, [projectId]);

  return (
    <TextField
      select
      fullWidth
      variant="outlined"
      size="small"
      label={label || "Agente de IA"}
      value={value || ""}
      onChange={e => onChange(e.target.value)}
      disabled={disabled}
      helperText={
        agents.length
          ? "O agente assume a ligação (persona, voz e ferramentas dele)."
          : "Nenhum agente criado. Crie em Agentes de IA → Novo agente."
      }
    >
      {agents.length === 0 && <MenuItem value="">(nenhum agente)</MenuItem>}
      {agents.map(a => (
        <MenuItem key={a.id} value={a.id}>{a.name}</MenuItem>
      ))}
    </TextField>
  );
};

export default AgentSelect;
